import { ActionBar } from '@dreryk/react-components';

import { VisitTemplates } from '~legacy.visit';
import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

export const VisitTemplatesTabContent = (): JSX.Element => {
   return (
      <ActionBar testId={'visitTemplates'} id={'visitTemplates'}>
         <VisitTemplates
            editSlot={({ handleSubmit, ready, onTemplateSaveSuccess, templateEmpty }) => (
               <>
                  <VisitTemplates.SendTemplateButton
                     handleSubmit={handleSubmit}
                     onSuccess={onTemplateSaveSuccess}
                     disabled={ready}
                     shouldConfirmEmptyTemplate={templateEmpty}
                  />
                  <FormsTemplates.CancelActionBarPrimaryLink />
               </>
            )}
            initialEditItem={undefined}
         />
      </ActionBar>
   );
};
